import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { CommonTooltipComponent } from './components/common-tooltip/common-tooltip.component';
import { CircleProgressbarComponent } from './components/circle-progressbar/circle-progressbar.component';
import { PaginationModule } from './components/pagination/pagination.module';
import { AccountTransactionsComponent } from '@app/_components/account-transactions/account-transactions.component';
import { ProfileUserComponent } from './components/profile-user/profile-user.component';

import { DisTouchmoveDirective } from '@app/_derectives/dis-touchmove.directive';

import { ShortenPipe } from '@pipes/shorten.pipe';
import { LineBreakPipe } from '@pipes/line-break.pipe';
import { ExerciseFormatPipe } from '@pipes/exercise-format.pipe';
import { KatexModule } from 'ng-katex';
import {
    CommonWrapperComponent,
    IndividualOrSummaryDataModalComponent,
    CommonModalComponent,
    StatPaginationComponent,
    StatLessonInfoComponent,
    StatMenuComponent,
    StatLessonDescComponent,
    StatLessonPupilComponent
} from '@teacher/components';
import { ExercisePuzzleComponent } from '@app/shared/components/preview-img/exercise-puzzle/exercise-puzzle.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

import { ProfileAwardsComponent } from './components/profile-awards/profile-awards.component';
import { AwardModule } from './components/award/award.module';
import { PageItemComponent } from './components/page-item/page-item.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        KatexModule,
        PaginationModule,
        ReactiveFormsModule,
        AwardModule,
        // material
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatDialogModule,
        MatSnackBarModule,
        MatGridListModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatPaginatorModule,
        MatListModule,
        MatCheckboxModule
    ],
    exports: [
        RouterModule,
        KatexModule,
        ExerciseFormatPipe,
        CommonTooltipComponent,
        CircleProgressbarComponent,
        AccountTransactionsComponent,
        ShortenPipe,
        LineBreakPipe,
        DisTouchmoveDirective,
        PaginationModule,
        ReactiveFormsModule,
        CommonWrapperComponent,
        IndividualOrSummaryDataModalComponent,
        CommonModalComponent,
        StatPaginationComponent,
        StatLessonInfoComponent,
        StatMenuComponent,
        StatLessonDescComponent,
        StatLessonPupilComponent,
        ExercisePuzzleComponent,
        ProfileUserComponent,
        ProfileAwardsComponent,
        PageItemComponent
    ],
    providers: [ShortenPipe, LineBreakPipe],
    declarations: [
        ExerciseFormatPipe,
        NotFoundComponent,
        CommonTooltipComponent,
        CircleProgressbarComponent,
        DisTouchmoveDirective,
        ShortenPipe,
        LineBreakPipe,
        AccountTransactionsComponent,
        CommonWrapperComponent,
        IndividualOrSummaryDataModalComponent,
        CommonModalComponent,
        StatPaginationComponent,
        StatLessonInfoComponent,
        StatMenuComponent,
        StatLessonDescComponent,
        StatLessonPupilComponent,
        ExercisePuzzleComponent,
        ProfileUserComponent,
        ProfileAwardsComponent,
        PageItemComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [ShortenPipe, LineBreakPipe]
        };
    }
}
